import { CSSProperties, MantineColor } from "@mantine/core"
import type { Conversation } from "@godalming/api-types"

export function getConversationLinkLabel(conversation: Pick<Conversation, "idConversation" | "convTitle" | "nameTypeCfC" | "descSubject">): string {
    const title = conversation.convTitle || `Conversation #${conversation.idConversation}`
    const type = conversation.descSubject
        ? `${conversation.nameTypeCfC} - ${conversation.descSubject}`
        : conversation.nameTypeCfC
    return `${title} · ${type}`
}

const normalizeConversationTypeKey = (value: string) => value.trim().toLowerCase()

export function getConversationTypeBadgeColor(typeNameOrCode: string): MantineColor {
    switch (normalizeConversationTypeKey(typeNameOrCode)) {
        case "cm":
        case "commendation":
            return "green"
        case "sl":
        case "subject log":
            return "gray"
        case "em":
        case "email to teachers, parents or student":
            return "blue"
        case "ec":
        case "early concern":
            return "orange"
        case "po":
        case "personal tutor 121":
            return "violet"
        case "bn":
        case "behaviour log":
            return "red"
        case "hl":
        case "health and wellbeing log":
            return "pink"
        case "ll":
        case "learning support log":
            return "yellow"
        case "pl":
        case "pastoral log":
            return "cyan"
        case "sf":
        case "student futures":
            return "teal"
        default:
            return "gray"
    }
}

export const badgeWrapStyles: Partial<Record<'root' | 'label', CSSProperties>> = {
    root: {
        height: 'auto',
    },
    label: {
        whiteSpace: 'normal',
        lineHeight: 1.15,
        textAlign: 'start',
    },
}
